<script>
    export default {
        
    }
</script>

<template>
    <div class="list-item-container is-relative skeleton">
        <div class="is-flex is-block list-item">
            <div class="list-item-visual">
                <div class="image list-item-image list-item-image-fallback has-shape-rounded"></div>
                <div class="list-item-date">
                    <span class="day"><progress class="progress" max="100"></progress></span>
                    <span class="date"><progress class="progress" max="100"></progress></span>
                    <span class="time"><progress class="progress is-small" max="100"></progress></span>
                </div>
            </div>
            <div class="list-item-info-wrapper">
                <div class="list-item-info">
                    <span class="wishlist-add has-text-grey">
                        <span class="icon">
                            <i class="fa-regular fa-heart fa-lg"></i>
                        </span>
                    </span>
                    <div class="list-item-location"><progress class="progress is-small" max="100"></progress></div>
                    <div class="title list-item-title"><progress class="progress is-large" max="100"></progress></div>
                    <div class="list-item-subtitle"><progress class="progress" max="100"></progress></div>
                    <div class="list-item-genre"><progress class="progress is-small" max="100"></progress></div>
                    <div class="list-item-duration"><progress class="progress is-small" max="100"></progress></div>
                    <div class="button button-order list-item-button is-disabled is-light is-rounded"><progress class="progress" max="100"></progress></div>
                </div>
            </div>
        </div>
    </div>
</template>
